module.exports = __webpack_public_path__ + "static/img/bg.150cd9aa.png";